
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  metaNavigationImprint: {
    id: "MetaNavigationImprint.imprint",
    defaultMessage: "Imprint",
  },
  metaNavigationLegals: {
    id: "MetaNavigationLegals.legals",
    defaultMessage: "Legals",
  },
  metaNavigationLegalsLink: {
    id: "MetaNavigationLegals.legalsLink",
    defaultMessage: "https://kwc.com/en_GB/footer-pages/allgemeine-gesch%C3%A4ftsbedingungen_pro",
  },
  metaNavigationPrivacy: {
    id: "MetaNavigationPrivacy.privacy",
    defaultMessage: "Privacy Policy",
  },
});

export default MESSAGES;